enum FeatureFlags {
  ORG_ENABLE_MODALITY_SPECIFIC_METRICS = 'ORG_ENABLE_MODALITY_SPECIFIC_METRICS',
  ORG_ENABLE_TEAMS_UI = 'ORG_ENABLE_TEAMS_UI',
  ORG_DYNAMIC_TARGET_UTILIZATION_PERCENTAGE_ENABLED = 'ORG_DYNAMIC_TARGET_UTILIZATION_PERCENTAGE_ENABLED',
  ORG_ENABLE_LOGS_SCROLLBAR = 'ORG_ENABLE_LOGS_SCROLLBAR',
  ORG_HIDE_BILLING_USAGE_COST_DETAILS = 'ORG_HIDE_BILLING_USAGE_COST_DETAILS',
  ORG_SUPPORT_ROLLING_DEPLOYS = 'ORG_SUPPORT_ROLLING_DEPLOYS',
}

export { FeatureFlags };
